<div class="tabs">
    <ul class="nav nav-tabs nav-width-equal">
        <li class="nav-item">
            <a class="nav-link" href="javascript:void(0)"
               [ngClass]="{ active: activeTab === 'own', disabled: ownItems.length === 0 }"
               [textContent]="myItemsLabel"
               (click)="setActiveTab('own')">
            </a>
        </li>
        <li class="nav-item">
            <a ycnDisabled class="nav-link" href="javascript:void(0)"
               [disabled]="!sharedWithMeEnabled"
               [ngClass]="{ active: activeTab === 'shared', disabled: sharedItems.length === 0 }"
               [textContent]="'Shared with Me'"
               (click)="setActiveTab('shared')">
            </a>
        </li>
    </ul>
</div>
<div class="tab-content">
    <div class="tab-pane" [ngClass]="{ active: activeTab === 'own' }">
        <ycn-open-item-list #ownItemListComponent
                            [attr.data-test-id]="myItemsLabel"
                            [isOwner]="true"
                            [items]="ownItems"
                            [itemTypeInfo]="itemTypeInfo"
                            [selectOnly]="selectOnly"
                            [savedItemType]="savedItemType"
                            [showRadioButtons]="showRadioButtons"
                            [selectedItemId]="ownSelectedItemId"
                            (itemActionHandler)="doActionOnItem($event)">
        </ycn-open-item-list>
    </div>
    <div class="tab-pane" [ngClass]="{ active: activeTab === 'shared' }">
        <ycn-open-item-list
                #sharedItemListComponent
                [isOwner]="false"
                [items]="sharedItems"
                [itemTypeInfo]="itemTypeInfo"
                [selectOnly]="selectOnly"
                [savedItemType]="savedItemType"
                [showRadioButtons]="showRadioButtons"
                [selectedItemId]="sharedSelectedItemId"
                (itemActionHandler)="doActionOnItem($event)">
        </ycn-open-item-list>
    </div>
</div>
